import React, { Fragment } from "react";
import Dialog from "../../../libraries/Dialog";
import { ButtonStyle } from "../../../style/basic/commonControls";
import { themeService } from "../../../theme/service/activeTheme.service";
import { languageService } from "../../../Language/language.service";
import { Button } from "reactstrap";
import StockViewTable from "./StockViewTable";
import _ from "lodash";
import { formFeildStyle } from "../../../wigets/forms/style/formFields";
import "./StockVoucher.css";
import StockInventory from "./StockInventory";
import ItemReduceVoucher from "./ItemReduceVoucher";

class StockVoucher extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stockData: [],
      adjustmentListData: [],
      ReasonsAndOperations: [],
      headerData: {},
      DocTypes: [],
      disableSubmit: false,
      selectedReason: "",
      additionalNotes: "",
      doc1: {
        value: "",
        selectedDocType: "",
      },
      doc2: {
        value: "",
        selectedDocType: "",
      },
      itemReduceVoucher: {
        isVisible: false,
        item: null,
        material: null,
      },
    };
    this.addStockToAdjustmentList = this.addStockToAdjustmentList.bind(this);
    this.adjustQuantity = this.adjustQuantity.bind(this);
    this.changeReason = this.changeReason.bind(this);
    this.setNotes = this.setNotes.bind(this);
    this.validateAll = this.validateAll.bind(this);
    this.filterFromAdjustmentList = this.filterFromAdjustmentList.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.HandleDropDownActions = this.HandleDropDownActions.bind(this);
  }
  componentDidMount() {
    let { StockData, ReasonsAndOperations, DocTypes } = this.props;
    if (StockData && ReasonsAndOperations && DocTypes) {
      this.setState({
        stockData: this.props.StockData,
        selectedReason: ReasonsAndOperations[0].name,
        ReasonsAndOperations: ReasonsAndOperations,
        DocTypes: DocTypes,
      });
    }
  }
  componentDidUpdate(prevProps, prevState) {
    let { adjustmentListData, selectedReason } = this.state;
    if (adjustmentListData != prevState.adjustmentListData || selectedReason != prevState.selectedReason) {
      let isReadyToSubmit = adjustmentListData.find((e) => !e.valid);
      this.setState({ disableSubmit: isReadyToSubmit ? true : false });
    }
  }
  validateAll(selectedReason) {
    let { adjustmentListData } = this.state;
    let x = JSON.parse(JSON.stringify(adjustmentListData));
    x.forEach((e) => {
      let isValid = this.Validate(e.qty, e.adjustment, selectedReason);
      e.valid = isValid;
    });
    this.setState({ adjustmentListData: x });
  }
  changeReason(reason) {
    this.setState({ selectedReason: reason });
    this.validateAll(reason);
  }
  Validate(qty, value, selectedReason) {
    let rs = this.state.ReasonsAndOperations.find((e) => e.name === selectedReason);
    if (rs && rs.operation === "-") {
      return value > qty ? false : true;
    }
    return true;
  }
  addStockToAdjustmentList(obj) {
    let { adjustmentListData, stockData, materialList } = this.state;
    let filteredStockData = stockData.filter((e) => e.materialId === obj.id);
    let newItems = [];

    if (filteredStockData.length > 0) {
      filteredStockData.forEach((noExistsInStockData) => {
        let found = adjustmentListData.find((e) => e.materialId === obj.id);
        if (!found) {
          newItems.push({
            ...noExistsInStockData,
            adjustment: 0,
            valid: true,
            isLinear: obj.linear ? true : false,
          });
        }
      });

      if (newItems.length > 0) {
        this.setState((prevState) => ({
          adjustmentListData: [...prevState.adjustmentListData, ...newItems],
        }));
      }
    } else {
      let ald = [
        ...adjustmentListData,
        {
          desc: obj.desc,
          materialId: obj.id,
          unitId: obj.id,
          adjustment: 0,
          valid: true,
          qty: 0,
          isLinear: obj.linear ? true : false,
        },
      ];
      this.setState({ adjustmentListData: ald });
    }
  }
  adjustQuantity(unitId, value) {
    let adList = this.state.adjustmentListData.map((e) => {
      if (e.unitId === unitId) {
        let isValid = value === "-" ? false : this.Validate(e.qty, value, this.state.selectedReason);
        return { ...e, adjustment: value, valid: isValid };
      }
      return e;
    });
    this.setState({
      adjustmentListData: adList,
    });
  }
  setNotes(value) {
    this.setState({ additionalNotes: value });
  }
  filterFromAdjustmentList(unitId) {
    let { adjustmentListData } = this.state;
    let filtered = adjustmentListData.filter((item) => item.unitId !== unitId);
    this.setState({ adjustmentListData: filtered });
  }
  HandleDropDownActions(object, value) {
    console.log(value);
    let { itemReduceVoucher } = this.state;
    let { materialList } = this.props;
    if (value === "reduce") {
      itemReduceVoucher.isVisible = true;
      itemReduceVoucher.item = object;
      itemReduceVoucher.material = materialList.find((e) => (e.id = object.materialId));
      this.setState({ itemReduceVoucher });
    }
  }
  onSubmit() {
    // let { Actions, wareHouse, Date, User } = this.props;
    // let { stockData, adjustmentListData, selectedReason, additionalNotes } = this.state;
    // let submitObject={}
    let { SubmitVoucher } = this.props;
    let { adjustmentListData, selectedReason, ReasonsAndOperations } = this.state;
    let rs = ReasonsAndOperations.find((e) => e.name === selectedReason);

    let ListData = adjustmentListData.reduce((list, element) => {
      return [
        ...list,
        {
          materialId: element.materialId,
          unitId: element.unitId,
          desc: element.unitId,
          batchNo: element.batchNo,
          qty:
            rs.operation === "+"
              ? parseInt(element.qty) + parseInt(element.adjustment)
              : rs.operation === "-"
              ? parseInt(element.qty) - parseInt(element.adjustment)
              : parseInt(element.qty),
        },
      ];
    }, []);

    SubmitVoucher(ListData);
  }
  render() {
    let { Actions, wareHouse, Date, User, materialList } = this.props;
    let {
      stockData,
      adjustmentListData,
      selectedReason,
      additionalNotes,
      ReasonsAndOperations,
      DocTypes,
      doc1,
      doc2,
      disableSubmit,
      itemReduceVoucher,
    } = this.state;
    const styles = {
      rowStyle: {
        display: "flex",
        justifyContent: "space-between",
      },
      whiteBoxStyle: {
        width: "200px",
        height: "30px",
        backgroundColor: "white",
        padding: "5px",
      },
    };
    return (
      <Fragment>
        <Dialog
          className={"manage-equipments-dialog"}
          isOpen={true}
          title={
            // <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>{"Stock Voucher"}</span>
            /* <button>fetch</button> */
            // </div>
          }
          body={
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <div className="SVContainer">
                <div className="SVHeader">
                  <div className="SVCol">
                    <div style={styles.rowStyle}>
                      <strong>WareHouse</strong> <div style={styles.whiteBoxStyle}>{wareHouse}</div>
                    </div>
                    <div style={styles.rowStyle}>
                      <strong>Date</strong> <div style={styles.whiteBoxStyle}>{Date}</div>
                    </div>
                    <div style={styles.rowStyle}>
                      <strong>User Id</strong> <div style={styles.whiteBoxStyle}>{User && User.email}</div>
                    </div>
                    <div style={styles.rowStyle}>
                      <strong>Reason</strong>

                      <SelectComponent
                        value={selectedReason}
                        options={ReasonsAndOperations.reduce((lst, curr) => [...lst, curr.name], [])}
                        onChange={(v) => this.changeReason(v)}
                      />
                    </div>
                    <div>
                      <StockInventory
                        materialList={materialList}
                        adjustmentListData={adjustmentListData}
                        callback={this.addStockToAdjustmentList}
                      />
                    </div>
                  </div>
                  <div className="SVCol">
                    <div style={styles.rowStyle}>
                      <strong>Doc#</strong>{" "}
                      <input
                        type="text"
                        style={{ ...styles.whiteBoxStyle, border: "none" }}
                        value={doc1.value}
                        onChange={(e) => {
                          this.setState({
                            doc1: {
                              ...doc1,
                              value: e.target.value,
                            },
                          });
                        }}
                      />
                    </div>
                    <div style={styles.rowStyle}>
                      <strong>DocType</strong>{" "}
                      <SelectComponent
                        value={doc1.selectedDocType}
                        options={DocTypes}
                        onChange={(value) => {
                          this.setState({
                            doc1: {
                              ...doc1,
                              selectedDocType: value,
                            },
                          });
                        }}
                      />
                    </div>
                    <div style={styles.rowStyle}>
                      <strong>Doc#</strong>{" "}
                      <input
                        type="text"
                        style={{ ...styles.whiteBoxStyle, border: "none" }}
                        value={doc2.value}
                        onChange={(e) => {
                          this.setState({
                            doc2: {
                              ...doc2,
                              value: e.target.value,
                            },
                          });
                        }}
                      />
                    </div>
                    <div style={styles.rowStyle}>
                      <strong>DocType</strong>{" "}
                      <SelectComponent
                        value={doc2.selectedDocType}
                        options={DocTypes}
                        onChange={(value) => {
                          this.setState({
                            doc2: {
                              ...doc2,
                              selectedDocType: value,
                            },
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div style={{ display: "flex", justifyContent: "center", width: "80%" }}>
                  <div
                    style={{
                      backgroundColor: "white",
                      width: "100%",
                      padding: "20px",
                      display: "flex",
                      justifyContent: "center",
                      marginBlockStart: "20px",
                      borderRadius: "10px",
                    }}
                  >
                    <div style={{ width: "100%", minHeight: "200px", paddingInline: "20px" }}>
                      <div
                        style={{
                          width: "100%",
                          height: "100%",
                          border: "1px solid #ccc",
                          padding: "10px",
                          borderRadius: "5px",
                          backgroundColor: "#f9f9f9",
                          transition: "background-color 0.3s ease",
                        }}
                      >
                        {adjustmentListData && (
                          <StockViewTable
                            data={adjustmentListData}
                            adjustQty={this.adjustQuantity}
                            onDeletePress={this.filterFromAdjustmentList}
                            HandleDropDownActions={this.HandleDropDownActions}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="SVNotesContainer">
                  <label htmlFor="" style={{ margin: "0" }}>
                    Notes
                  </label>
                  <textarea
                    value={additionalNotes}
                    rows="5"
                    cols="50"
                    placeholder={languageService("Add notes")}
                    className="SVNotes"
                    onChange={(e) => {
                      this.setNotes(e.target.value);
                      // Actions("set", { note: e.target.value });
                    }}
                  />
                </div>
              </div>
            </div>
          }
          footer={
            <Fragment>
              <Button onClick={this.onSubmit} style={themeService(ButtonStyle.commonButton)} disabled={disableSubmit}>
                {languageService("Apply")}
              </Button>{" "}
              <Button
                onClick={() => {
                  Actions("cancel");
                }}
                style={themeService(ButtonStyle.commonButton)}
              >
                {languageService("Cancel")}
              </Button>
            </Fragment>
          }
        ></Dialog>
        <ItemReduceVoucher
          wareHouse={wareHouse}
          User={User}
          Date={Date}
          stockData={stockData}
          modalVisible={itemReduceVoucher.isVisible}
          stockToReduce={itemReduceVoucher.item}
          material={itemReduceVoucher.material}
          onClose={() => {
            this.setState({ itemReduceVoucher: { ...this.state.itemReduceVoucher, isVisible: false, item: null, material: null } });
          }}
        />
      </Fragment>
    );
  }
}

export default StockVoucher;

const SelectComponent = ({ value, options, onChange }) => {
  return (
    <div style={themeService(formFeildStyle.feildStyle)}>
      <select
        value={value}
        style={{ ...themeService(formFeildStyle.inputStyle), ...{ float: "none" }, width: "200px" }}
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map((item, index) => (
          <option key={index} value={item}>
            {languageService(item)}
          </option>
        ))}
      </select>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/StockView/StockVoucher/StockVoucher.jsx